import {
    EXAM_TYPE_EGE,
    EXAM_INNER_TEST,
    EXAM_MEDIUM_BALL_FROM_DOC,
    EXAM_ACCREDITATION,
} from '@assets/js/constants/examsResults';

export const configExamTypes = [
    {value: EXAM_TYPE_EGE, name: 'ЕГЭ'},
    {value: EXAM_INNER_TEST, name: 'Внутреннее испытание'},
    {value: EXAM_MEDIUM_BALL_FROM_DOC, name: 'Средний балл документа об образовании'},
    {value: EXAM_ACCREDITATION, name: 'Аккредитация'},
];

export const configExamTypesTranslatedConf = [
    {value: EXAM_TYPE_EGE, name: 'exams.unified_state_exam'},
    {value: EXAM_INNER_TEST, name: 'exams.internal_entrance_test'},
    {value: EXAM_MEDIUM_BALL_FROM_DOC, name: 'exams.average_grade_from_education_document'},
    {value: EXAM_ACCREDITATION, name: 'exams.accreditation'},
];
